<template>
    <div class="form-group">
        <label 
            :for="id" 
            class="pppp-label">
            {{ getLabel }}
        </label>
        <input 
            type="file" 
            :id="id" 
            :name="getName" 
            class="form-control pppp-input filestyle" 
            :placeholder="placeholder"
            :accept="accept"
            :required="required" />
        <div v-if="required" class="pppp-validation-msg">
            <span class="glyphicon glyphicon-exclamation-sign"></span> Tämä kenttä on pakollinen!
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFile',
    props: {
        id:  String,
        name: String,
        label: {
            type: String,
            default: 'Tiedosto'
        },
        required: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: 'Tiedostoa ei valittu'
        },
        maxFileSize: String,
        accept: String
    },
    computed: {
        getLabel() {
            let label = this.label;
            if (this.required) {
                label = '* ' + label;
            }
            if (this.maxFileSize) {
                label += ' (max ' + this.maxFileSize + ')';
            }
            return label;
        },
        getName() {
            if (! this.name) {
                return this.id;
            }
            return this.name;
        }
    },
    mounted() {
        // Initialize Bootstrap FileStyle
        /*window.$(".filestyle").filestyle({
            buttonText: 'Valitse',
            placeholder: this.placeholder
        });*/

        // Bootstrap FileStyle 1.2.3 placeholder option is not working
        // for some weird reason, set it manually then...
        //window.$(".bootstrap-filestyle input").attr('placeholder', this.placeholder);
    }
}
</script>

<style scoped>

</style>
